import { createBrowserHistory } from 'history'
import { createReduxHistoryContext } from 'redux-first-history'

export default createReduxHistoryContext({
    history: createBrowserHistory(),
})
